import { Tooltip, TooltipProps } from '@prenuvo/halo';

type SelectTooltipProps = Pick<TooltipProps, 'children' | 'content' | 'open'>;

export function SelectTooltip({ children, content, open }: SelectTooltipProps) {
  return (
    <Tooltip
      className="bg-stone-700 text-xs text-neutral-50 dark:bg-stone-700 dark:text-neutral-50"
      content={content}
      open={open}
    >
      {children}
    </Tooltip>
  );
}
